<template>
  <div class="flex flex-1 flex-col justify-end home-container">
    <conversation-list-wrap v-if="isFullPageView" />
    <team-availability :available-agents="availableAgents" :has-conversation="!!conversationSize"
      @start-conversation="startConversation" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import TeamAvailability from 'widget/components/TeamAvailability.vue';
import routerMixin from 'widget/mixins/routerMixin';
import getConfig from 'widget/helpers/config';

import configMixin from '../mixins/configMixin';
import ConversationListWrap from '../components/ConversationListWrap.vue';

export default {
  name: 'Home',
  components: {
    TeamAvailability,
    ConversationListWrap
  },
  mixins: [configMixin, routerMixin],
  props: {
    hasFetched: {
      type: Boolean,
      default: false,
    },
    isCampaignViewClicked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      availableAgents: 'agent/availableAgents',
      activeCampaign: 'campaign/getActiveCampaign',
      conversationSize: 'conversation/getConversationSize',
    }),
    isFullPageView() {
      return getConfig().webChannel.isFullPageView;
    },
  },
  methods: {
    startConversation() {
      if (this.preChatFormEnabled && (!this.conversationSize || this.isFullPageView)) {
        return this.replaceRoute('prechat-form');
      }

      return this.replaceRoute('messages');
    },
  },
};
</script>
<style scoped lang="scss">
.is-full-page-view {
  .home-container {
    width: 100%;
    max-width: 1020px;
    align-items: center;
    // overflow-y: auto;
    justify-content: space-between;
  }

  .conversation-list-wrapper {
    width: 100%;
    justify-content: center;
  }
}
</style>